import React from 'react'

export default class Loading extends React.Component {

    render() {
        return (
            <div class="d-flex vh-100 justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        )
    }
}
